import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { ClinicUserClinicFragment, ClinicUserFragment } from 'shared/types/graphql';
import { env } from 'env';

const useTagManager = (user: ClinicUserFragment | null, currentClinic: ClinicUserClinicFragment | null): boolean => {
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    if (user && env.REACT_APP_PRODUCTION === 'true') {
      try {
        TagManager.dataLayer({
          dataLayer: {
            userId: user.id,
            clinicName: currentClinic?.name,
            is_production: env.REACT_APP_PRODUCTION === 'true',
          },
        });
        setHasInitialized(true);
      } catch (error) {
        console.log(error);
      }
    }
  }, [user, currentClinic]);

  return hasInitialized;
};

export default useTagManager;
